var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 6.3H4.2V7.7H2.8V6.3ZM2.8 9.1H4.2V10.5H2.8V9.1ZM5.6 6.3H7V7.7H5.6V6.3ZM5.6 9.1H7V10.5H5.6V9.1ZM8.4 6.3H9.8V7.7H8.4V6.3ZM8.4 9.1H9.8V10.5H8.4V9.1Z",
    fill: "#62666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 14H11.2C11.9721 14 12.6 13.3721 12.6 12.6V2.8C12.6 2.0279 11.9721 1.4 11.2 1.4H9.8V0H8.4V1.4H4.2V0H2.8V1.4H1.4C0.6279 1.4 0 2.0279 0 2.8V12.6C0 13.3721 0.6279 14 1.4 14ZM11.2 4.2L11.2007 12.6H1.4V4.2H11.2Z",
    fill: "#62666C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGray);
export default __webpack_public_path__ + "static/media/calendar_gray.358aff9947f3ea5ae499350a47f0629f.svg";
export { ForwardRef as ReactComponent };